import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import AuthService from "./AuthService";

export default function AuthGuard({ allowedRoles }) {
  const [isValid, setIsValid] = useState(AuthService.hasValidSession());
  const location = useLocation();

  // Validate on mount and every route change
  useEffect(() => {
    setIsValid(AuthService.hasValidSession());
  }, [location]);

  // Protect against bfcache (Back-Forward Cache)
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        if (!AuthService.hasValidSession()) {
          AuthService.logout();
        } else {
          setIsValid(true);
        }
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);

  if (!isValid) {
    return <Navigate to="/login" replace />;
  }

  // Role based authorization
  if (allowedRoles && allowedRoles.length > 0) {
    const role = AuthService.getRole();
    if (!allowedRoles.includes(role)) {
      if (role === "ADMIN" || role === "SUPER_ADMIN") return <Navigate to="/admin" replace />;
      if (role === "OWNER") return <Navigate to="/owner" replace />;
      if (role === "ALT_DRIVER") return <Navigate to="/alting-driver/dashboard" replace />;
      return <Navigate to="/account" replace />;
    }
  }

  return <Outlet />;
}
